import { combineReducers } from 'redux';
import types from './types';

/* State Shape
{
    pending: bool
    success:{
        hasBeenSuccessful: bool,
        activeAccount: string
    }
    failed: {
        hasFailed: bool,
        message: string
    }
}
*/

interface ILoginFailed {
  type: string;
  payload: {
    errorCode: number;
    message: string;
  };
}

const pending = (
  state: any = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SIGNIN_PENDING:
      return payload;
    default:
      return state;
  }
};

const failed = (
  state = {
    hasFailed: false,
    message: ''
  },
  { type, payload }: ILoginFailed
) => {
  switch (type) {
    case types.SIGNIN_ERROR:
      return payload;
    default:
      return state;
  }
};

const success = (
  state: boolean = false,
  {
    type
  }: {
    type: any;
  }
): boolean => {
  switch (type) {
    case types.SIGNIN_SUCCESS:
      return true;

    case types.SIGNOUT:
      return false;

    default:
      return state;
  }
};

const activeAccount = (
  state: string = '',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
): string => {
  switch (type) {
    case types.CHANGE_ACTIVE_ACCOUNT:
      return payload;

    case types.SIGNOUT:
      return '';

    default:
      return state;
  }
};

const activeAccountCountry = (
  state: string = '',
  {
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
): string => {
  switch (type) {
    case types.SET_ACTIVE_ACCOUNT_COUNTRY:
      return payload;

    case types.SIGNOUT:
      return '';

    default:
      return state;
  }
};

const activeAccountHasChanged = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
): boolean => {
  switch (type) {
    case types.ACTIVE_ACCOUNT_HAS_CHANGED:
      return payload;

    case types.SIGNOUT:
      return false;

    default:
      return state;
  }
};

const shouldSelectAccount = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SET_SELECT_ACCOUNT:
      return payload;

    case types.SIGNOUT:
      return false;

    default:
      return state;
  }
};

const shouldVerify = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SET_SHOULD_VERIFY:
      return payload;

    case types.SIGNOUT:
      return false;

    default:
      return state;
  }
};

const shouldUpdateInfo = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SET_SHOULD_UPDATE_INFO:
      return payload;

    case types.SIGNOUT:
      return false;

    default:
      return state;
  }
};

const usesTwoStepAuth = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SET_TWO_STEP_AUTH:
      return payload;

    case types.SIGNOUT:
      return false;

    default:
      return state;
  }
};

const navigateToSamsungInvoicePage = (
  state: boolean = false,
  {
    type,
    payload
  }: {
    type: string;
    payload: boolean;
  }
) => {
  switch (type) {
    case types.SET_SAMSUNG_USER_SIGN_IN:
      return payload;

    default:
      return state;
  }
};

const signinReducer = combineReducers({
  usesTwoStepAuth,
  shouldVerify,
  shouldUpdateInfo,
  shouldSelectAccount,
  pending,
  failed,
  success,
  activeAccount,
  activeAccountCountry,
  activeAccountHasChanged,
  navigateToSamsungInvoicePage
});

export default signinReducer;
